module.exports = __webpack_public_path__ + "img/Bahnhof_Anina_2kl.be62459c.jpg";